import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface CTAProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
}

const CallToAction = ({
  title = "Pripravljen za prvi korak?",
  subtitle = "Kontaktirajte nas za brezplačen posvet in začnite svoje potovanje do boljše samopodobe.",
  buttonText = "Rezerviraj posvet",
  buttonLink = "/kontakt",
}: CTAProps) => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-medical-50 to-medical-100">
      <div className="container mx-auto px-6 md:px-8">
        <div className="glass-pink p-8 md:p-12 lg:p-16 text-center max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 opacity-0 animate-fade-in">
            {title}
          </h2>
          <p className="text-lg text-gray-700 mb-8 opacity-0 animate-fade-in animate-delay-100">
            {subtitle}
          </p>
          <Button
            asChild
            className="glass-card bg-medical-500 hover:bg-medical-600 text-white rounded-full px-8 py-6 text-lg font-medium opacity-0 animate-fade-in animate-delay-200 btn-hover-effect"
          >
            <Link to={buttonLink}>{buttonText}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;